import React from "react";
import { GenericTableColumn } from "@ui-components/Table/GenericTable";
import { ReactComponent as IconEye } from "@assets/Icons/Icon_Eye.svg";
export interface LogItem {
    timestamp: string;
    level: string;
    message: string;
}

/**
 * 4 columnas:
 *   Timestamp | Severity Level | Message (truncado) | Details
 */
export const logsColumns = (
    onDetailsClick: (row: LogItem) => void
): GenericTableColumn<LogItem>[] => [
        {
            header: "Timestamp",
            accessor: "timestamp",
        },
        {
            header: "Severity Level",
            accessor: "level",
        },
        {
            header: "Message",
            // Truncamos el texto a, por ejemplo, 150 caracteres en vez de 50
            renderCell: (row: LogItem) => {
                const full = row.message || "";
                const truncated =
                    full.length > 85 ? full.slice(0, 85) + "..." : full;
                return truncated;
            },
        },
        {
            header: "Details",
            renderCell: (row: LogItem) => (
                <button
                    className="flex items-center justify-center
                border border-semantic-border-secondary
                rounded
                text-semantic-text-secondary
                hover:bg-semantic-state-active
                w-10 h-10"
                    onClick={() => onDetailsClick(row)}
                >
                    <IconEye className="w-6 h-6" />
                </button>
            ),
        },
    ];
